// Material 3 Switch (52x32 track, 16px handle growing to 24px when selected)
// Props: checked, onChange, disabled, label, size aside from MUI's: inputProps etc.
(function () {
  const { Switch: MuiSwitch, FormControlLabel } = MaterialUI;

  function Switch({ label, sx = {}, ...props }) {
    const control = (
      <MuiSwitch
        disableRipple
        sx={{
          width: 52,
          height: 32,
          p: 0,
          overflow: 'visible',
          '& .MuiSwitch-switchBase': {
            p: 0,
            width: 32,
            height: 32,
            top: 0,
            left: 0,
            borderRadius: '50%',
            transition: 'transform var(--m3-duration-short) var(--m3-easing-standard)',
            '&:hover': { backgroundColor: 'color-mix(in srgb, var(--m3-on-surface) 8%, transparent)' },
            '&.Mui-checked': {
              transform: 'translateX(20px)',
              '&:hover': { backgroundColor: 'color-mix(in srgb, var(--m3-primary) 8%, transparent)' },
              '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'var(--m3-primary)',
                borderColor: 'var(--m3-primary)'
              },
              '& .MuiSwitch-thumb': { width: 24, height: 24, backgroundColor: 'var(--m3-on-primary)' }
            },
            '&.Mui-focusVisible': { outline: '3px solid var(--m3-secondary)', outlineOffset: 2 },
            '&.Mui-disabled': { opacity: 0.38 }
          },
          '& .MuiSwitch-thumb': {
            width: 16,
            height: 16,
            boxShadow: 'none',
            backgroundColor: 'var(--m3-outline)',
            transition: 'all var(--m3-duration-short) var(--m3-easing-standard)'
          },
          '& .MuiSwitch-track': {
            borderRadius: 'var(--m3-shape-full)',
            opacity: 1,
            backgroundColor: 'var(--m3-surface-container-highest)',
            border: '2px solid var(--m3-outline)',
            boxSizing: 'border-box'
          },
          ...sx
        }}
        {...props}
      />
    );
    return label ? <FormControlLabel control={control} label={label} /> : control;
  }

  window.Components = window.Components || {};
  window.Components.Switch = Switch;
})();
